import { render, staticRenderFns } from "./TargetBreaks.vue?vue&type=template&id=bde800e2"
import script from "./TargetBreaks.vue?vue&type=script&lang=js"
export * from "./TargetBreaks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports